<template>
        <div class="titolo-card">
          <h1>Privacy per Videocall: {{ privacyText }}</h1>
          <!-- Stato di visibilità -->
          <h1>Pagina privacy: {{ hiddenStatusText }}</h1>
          <button
            :disabled="isPageLoading || !!pageError || !userId"
            @click="toggleHiddenStatus"
          >
            {{ hiddenStatusButtonText }}
          </button>
        </div>

        <p v-if="isPageLoading" class="user-alimentazione-status" role="status">
          Caricamento alimentazioni…
        </p>
        <p v-else-if="pageError" class="user-alimentazione-status user-alimentazione-status--error" role="alert">
          {{ pageError }}
        </p>

        <!-- Loop attraverso ogni set di dati di alimentazione -->
        <div
          v-for="(data, index) in sortedAlimentazioni"
          :key="getAlimentazioneKey(data, index)"
          class="card-black-orders"
        >
          <!-- Header dell'alimentazione che può essere cliccato per espandere i dettagli -->
          <div class="card-header2">
  <div class="header-row" @click="toggleAccordion(index)">
    <div class="icon-column">
      <span class="material-icons">
        {{ currentAccordion === index ? 'expand_less' : 'expand_more' }}
      </span>
    </div>

    <div class="text-column">
      <div class="header-text2">Creazione: {{ formatDate(data.dataCreazione) }}</div>

    </div>

        <!-- Display Piano di Integrazione and Link Alimentazione status -->
        <div class="additional-info">
          <div class="header-text2">Consegna: {{ formatDate(data.dataFileCaricato) }}</div>

      <span>Alimentazione caricata: <strong>{{ data.linkAlimentazione || data.fileUrl ? 'SI' : 'NO' }}</strong></span>
    </div>


    <!-- 
    <button @click.stop="deleteAlimentazione(index)" class="delete-button">Elimina</button> -->
  </div>
</div>


          <!-- Dettagli dell'alimentazione -->
          <div v-if="currentAccordion === index" class="order-details">
            <div class="grid-item full-width2">
              <label for="'videocall-' + index">Video call necessaria: </label>
              <select :id="'videocall-' + index" v-model="data.videocall">
                <option disabled value="">Seleziona</option>
                <option>SI</option>
                <option>NO</option>
              </select>
            </div>

            <!-- Sezione per le prenotazioni 
            <div v-if="data.prenotazioni && data.prenotazioni.length" class="prenotazioni-container">
              <h3>Prenotazioni video call:</h3>
              <ul>
                <li v-for="(prenotazione, pIndex) in data.prenotazioni" :key="pIndex">
                  <strong>Data:</strong> {{ formatSlotDate(prenotazione.data) }}<br>
                  <strong>Orario:</strong> {{ prenotazione.orario }}<br>
                  <strong>Nutrizionista:</strong> {{ prenotazione.nutrizionista }}
                </li>
              </ul>
            </div>-->

            <div class="grid-container2">
              <!-- Campo per la nota interna -->
              <div class="grid-item">
                <label for="'nota1-' + index">Nota Interna (non verrà letta dall'utente):</label>
                <textarea :id="'nota1-' + index" v-model="data.nota1" class="user-textarea-red"></textarea>
              </div>

              <!-- Campo per la nota per il cliente -->
              <div class="grid-item">
                <label for="'nota2-' + index">Nota per il cliente:</label>
                <textarea :id="'nota2-' + index" v-model="data.nota2" class="user-textarea"></textarea>
              </div>


      <div class="grid-item full-width">
  <label>Integrazione:</label>
  <div class="integrazione-cell">
    <button
      type="button"
      class="integrazione-button"
      @click="openIntegrazioneModal(data)"
    >
      <span class="material-icons integrazione-button__icon">fact_check</span>
      <span>{{ getIntegrationLabel(data) }}</span>
    </button>
    <div v-if="getIntegrationSummary(data)" class="integrazione-summary">
      {{ getIntegrationSummary(data) }}
    </div>
  </div>
</div>

<div class="grid-item">
  <label for="'nutrizionista-' + index">Nutrizionista azione:</label>
  <div :id="'nutrizionista-' + index" class="note-display">
    {{ data.nutrizionista || 'Nessuna nutrizionista' }}
  </div>
</div>

<div class="grid-item">
  <label for="'videocall-' + index">Azione:</label>
  <div :id="'videocall-' + index" class="note-display">
    {{ data.videocall || 'Azione' }}
  </div>
</div>


<!-- Campo per kcalalimentazioni -->
<div class="grid-item">
  <label for="'strategia-' + index">Strategia:</label>
  <input type="text" :id="'strategia-' + index" v-model="data.strategia" class="user-input">
</div>


<!-- Campo per kcalalimentazioni -->
<div class="grid-item">
  <label for="'kcalalimentazioni-' + index">Kcal Alimentazioni:</label>
  <input type="text" :id="'kcalalimentazioni-' + index" v-model="data.kcalalimentazioni" class="user-input">
</div>




<div class="grid-item">
  <label for="'nutrizionistadiet-' + index">Nutrizionista alimentazione:</label>
  <div :id="'nutrizionistadiet-' + index" class="note-display">
    {{ data.nutrizionistadiet || 'Nessuna nutrizionista' }}
  </div>
</div>




<!--              <div class="grid-item full-width">
                <label for="'linkAlimentazione-' + index">Link Alimentazione (inserisci il link di dropbox):</label>
                <input type="text" :id="'linkAlimentazione-' + index" v-model="data.linkAlimentazione" class="user-input">
              </div> -->




              <div class="grid-item full-width">
  <label for="'file-upload-' + index" class="section-title">Caricamento qui il file dell' Alimentazione:</label>
  <div
    class="drop-zone"
    @dragover.prevent
    @dragleave="isDragging = false"
    @drop.prevent="handleDrop($event, index)"
    :class="{ 'drop-zone--active': isDragging }"
  >
    <span v-if="!isDragging">Trascina qui il file o <button @click="uploadFile(index)">Carica File</button></span>
    <span v-if="isDragging">Rilascia il file qui</span>
    <span v-if="isLoading" class="minimal-loader">Caricamento in corso...</span>
  </div>
  <div v-if="data.fileUrl" class="file-actions">
    <span>File caricato:</span>
    <a :href="data.fileUrl" target="_blank" rel="noopener noreferrer">Visualizza</a>
    <button
      type="button"
      class="send-email-btn"
      :disabled="isSendingEmail(data, index)"
      @click="sendEmailForAlimentazione(data, index)"
    >
      {{ isSendingEmail(data, index) ? 'Invio...' : 'Invia per email' }}
    </button>
  </div>
</div>


<div class="divider"></div>
<div class="divider"></div>


<div class="grid-item">
  <label for="'lavtrainer-' + index">Trainer allenamento:</label>
  <div :id="'lavtrainer-' + index" class="note-display">
    {{ data.lavtrainer || 'Nessuna trainer' }}
  </div>
</div>

<div class="grid-item">
  <label for="'lavorato-' + index">Allenamento:</label>
  <div :id="'lavtlavoratorainer-' + index" class="note-display">
    {{ data.lavorato || 'Nessuna allenamento' }}
  </div>
</div>

<div class="grid-item">
  <label for="'allenamento-' + index">Allenamento:</label>
  <input type="text" :id="'allenamento-' + index" v-model="data.allenamento" class="user-input">
</div>


  <div class="grid-item">
  <label for="'freqallenamento-' + index"> Freq. Allenamento:</label>
  <input type="text" :id="'freqallenamento-' + index" v-model="data.freqallenamento" class="user-input">
</div>


<div class="grid-item">
  <label for="'noteselect-' + index">Note selezionate:</label>
  <div :id="'noteselect-' + index" class="note-display">
    <span v-if="data.noteselect === 'damodificare'">Da modificare</span>
    <span v-else-if="data.noteselect === 'corretta'">Corretta</span>
    <span v-else>NOTA NON NECESSARIA</span>
  </div>
</div>




<div class="grid-item">
  <label for="'noteinterna-' + index">Note per modifica:</label>
  <div :id="'noteinterna-' + index" class="note-display">
    {{ data.noteinterna || 'Nessuna nota disponibile' }}
  </div>
</div>



<div class="grid-item">
  <label for="'notetrainer-' + index">Trainer nota:</label>
  <div :id="'notetrainer-' + index" class="note-display">
    {{ data.notetrainer || 'Nessun trainer' }}
  </div>
</div>





            </div>
          </div>
        </div>
      <div class="button-container">
<button class="staff-button-positive" type="button" :disabled="isPageLoading || !!pageError" @click="addNewMonth">Aggiungi Alimentazione</button>
        <button class="staff-button-positive" type="submit" :disabled="isPageLoading || !!pageError" @click="saveAlimentazione">Salva</button>
      </div>

  <IntegrazioneModal
    v-if="integrazioneModal.visible"
    :key="`${userId}:${integrazioneModal.alimentazioneId}`"
    :user-id="userId"
    :alimentazione-id="integrazioneModal.alimentazioneId"
    :initial-entry="integrazioneModal.initialEntry"
    @close="closeIntegrazioneModal"
    @saved="handleIntegrazioneSaved"
  />
</template>


<script>
import { ref, computed, watch, defineAsyncComponent } from 'vue';
import { getFirestore, doc, getDoc, collection, getDocs, Timestamp, updateDoc } from 'firebase/firestore';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import {
  getIntegrationLabel,
  getIntegrationSummary,
  preserveIntegrationFields,
} from '@/lib/integrazione';
import { saveProtectedAlimentazioni } from '@/lib/integrazioneStore';

const IntegrazioneModal = defineAsyncComponent(() => import('../module/IntegrazioneModal.vue'));


export default {
  components: {
    IntegrazioneModal,
  },
  props: {
    userId: String
  },
  setup(props) {
    const alimentazione = ref([]);
    const baseAlimentazioni = ref([]);
    const isPageLoading = ref(false);
    const pageError = ref('');
    const userPrivacyAccettata = ref(false);
    const userHidden = ref(false); // Dichiara la variabile userHidden come ref
    const currentAccordion = ref(null);
    const codFiscale = ref('');
    const luogoNascita = ref('');
    const isLoading = ref(false); // Stato per il loader
    const isDragging = ref(false);
    const showTooltip = ref(null); // Variabile per mostrare/nascondere il tooltip
    const sendingEmail = ref({});
    const integrazioneModal = ref({
      visible: false,
      alimentazioneId: '',
      initialEntry: null,
    });
    let activeLoadRequest = 0;

    const cloneAlimentazioni = (entries) => (Array.isArray(entries) ? entries : []).map((entry) => ({
      ...entry,
      integrazioneProducts: Array.isArray(entry?.integrazioneProducts)
        ? [...entry.integrazioneProducts]
        : entry?.integrazioneProducts,
    }));

    const replaceSavedAlimentazioni = (entries) => {
      const normalized = cloneAlimentazioni(entries);
      alimentazione.value = normalized;
      baseAlimentazioni.value = cloneAlimentazioni(normalized);
      return normalized;
    };

    const isCurrentUser = (targetUserId) => props.userId === targetUserId;

    const hasStableAlimentazioneIds = (entries, { notify = true } = {}) => {
      const ids = (Array.isArray(entries) ? entries : []).map((entry) => String(entry?.id || '').trim());
      if (ids.some((id) => !id)) {
        if (notify) {
          alert("Una alimentazione storica è priva di identificativo stabile. Per sicurezza il salvataggio è bloccato finché gli ID non vengono allineati.");
        }
        return false;
      }
      if (new Set(ids).size !== ids.length) {
        if (notify) {
          alert("Sono presenti alimentazioni con lo stesso identificativo. Ricarica la pagina prima di salvare.");
        }
        return false;
      }
      return true;
    };

    const createAlimentazioneId = () => {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
      }
      return `alim-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    };

    const getAlimentazioneKey = (item, fallbackIndex) => {
      if (item?.id) return item.id;
      if (item?.dataCreazione && typeof item.dataCreazione.toMillis === 'function') {
        return `dc-${item.dataCreazione.toMillis()}`;
      }
      return `idx-${fallbackIndex}`;
    };


    const sortedAlimentazioni = computed(() => {
  return [...alimentazione.value].sort((a, b) => {
    const dateA = a.dataCreazione ? a.dataCreazione.toDate() : new Date(0); // Usa una data molto vecchia come fallback
    const dateB = b.dataCreazione ? b.dataCreazione.toDate() : new Date(0);
    return dateA - dateB; // Ordinamento crescente
  });
});

    const resolveAlimentazioneIndex = (item) => alimentazione.value.indexOf(item);
    const isSendingEmail = (item, fallbackIndex) => {
      const key = getAlimentazioneKey(item, fallbackIndex);
      return !!sendingEmail.value[key];
    };
    const setSendingEmail = (item, fallbackIndex, value) => {
      const key = getAlimentazioneKey(item, fallbackIndex);
      if (value) {
        sendingEmail.value = { ...sendingEmail.value, [key]: true };
        return;
      }
      if (!sendingEmail.value[key]) {
        return;
      }
      const next = { ...sendingEmail.value };
      delete next[key];
      sendingEmail.value = next;
    };

    const openIntegrazioneModal = (item) => {
      const resolvedIndex = resolveAlimentazioneIndex(item);
      if (resolvedIndex < 0) return;
      const alimentazioneId = item?.id ? String(item.id).trim() : '';
      const isPersisted = baseAlimentazioni.value.some(
        (entry) => String(entry?.id || '') === alimentazioneId
      );
      if (!alimentazioneId) {
        alert("Questa alimentazione storica non ha ancora un identificativo stabile e non può ricevere un'integrazione.");
        return;
      }
      if (!isPersisted) {
        alert("Salva prima l'alimentazione per assegnarle un identificativo stabile.");
        return;
      }
      integrazioneModal.value = {
        visible: true,
        alimentazioneId,
        initialEntry: { ...alimentazione.value[resolvedIndex] },
      };
    };

    const closeIntegrazioneModal = () => {
      integrazioneModal.value = {
        visible: false,
        alimentazioneId: '',
        initialEntry: null,
      };
    };

    const updateIntegrationEntryLocally = (entriesRef, savedEntry, alimentazioneId) => {
      const list = Array.isArray(entriesRef.value) ? [...entriesRef.value] : [];
      const entryIndex = list.findIndex((entry) => String(entry?.id || '') === alimentazioneId);
      if (entryIndex < 0) return;
      list.splice(
        entryIndex,
        1,
        preserveIntegrationFields({ ...list[entryIndex] }, savedEntry)
      );
      entriesRef.value = list;
    };

    const handleIntegrazioneSaved = (savedEntry) => {
      const alimentazioneId = String(
        savedEntry?.id || integrazioneModal.value.alimentazioneId || ''
      );
      if (savedEntry && alimentazioneId) {
        updateIntegrationEntryLocally(alimentazione, savedEntry, alimentazioneId);
        updateIntegrationEntryLocally(baseAlimentazioni, savedEntry, alimentazioneId);
      }
      closeIntegrazioneModal();
    };


    const handleDrop = async (event, index) => {
  isDragging.value = false;
  const file = event.dataTransfer.files[0];
  if (!file) return;

  const targetUserId = props.userId;
  const entriesSnapshot = cloneAlimentazioni(alimentazione.value);
  const baseEntriesSnapshot = cloneAlimentazioni(baseAlimentazioni.value);
  if (!targetUserId) {
    alert('Utente non trovato.');
    return;
  }
  if (!hasStableAlimentazioneIds(entriesSnapshot)) return;

  if (file.size > 10 * 1024 * 1024) {
    alert("Il file selezionato supera i 10 MB. Seleziona un file più piccolo.");
    return;
  }

  const fileType = file.type.includes('pdf') ? 'pdf' : file.type.includes('jpeg') ? 'jpg' : null;
  if (!fileType) {
    alert('Seleziona solo file PDF o JPG');
    return;
  }

  try {
    isLoading.value = true;
    const storage = getStorage();
    const filePath = `alimentazioni/${targetUserId}/${index}/${file.name}`;
    const fileRef = storageRef(storage, filePath);
    await uploadBytes(fileRef, file);

    const fileUrl = await getDownloadURL(fileRef);
    const dataFileCaricato = Timestamp.fromDate(new Date());
    const entriesToSave = isCurrentUser(targetUserId)
      ? cloneAlimentazioni(alimentazione.value)
      : entriesSnapshot;
    if (!entriesToSave[index]) {
      throw new Error('Alimentazione non trovata durante il caricamento.');
    }
    Object.assign(entriesToSave[index], { fileUrl, fileType, dataFileCaricato });
    if (isCurrentUser(targetUserId) && alimentazione.value[index]) {
      Object.assign(alimentazione.value[index], { fileUrl, fileType, dataFileCaricato });
    }

    await saveFileUrlToFirestore({
      targetUserId,
      index,
      fileUrl,
      fileType,
      dataFileCaricato,
      entries: entriesToSave,
      baseEntries: baseEntriesSnapshot,
    });
    if (isCurrentUser(targetUserId)) alert('File caricato con successo!');
  } catch (error) {
    console.error('Errore durante il caricamento del file:', error);
    if (isCurrentUser(targetUserId)) alert('Errore durante il caricamento del file.');
  } finally {
    if (isCurrentUser(targetUserId)) isLoading.value = false;
  }
};




const uploadFile = async (index) => {
  const targetUserId = props.userId;
  const entriesSnapshot = cloneAlimentazioni(alimentazione.value);
  const baseEntriesSnapshot = cloneAlimentazioni(baseAlimentazioni.value);
  if (!targetUserId) {
    alert('Utente non trovato.');
    return;
  }
  if (!hasStableAlimentazioneIds(entriesSnapshot)) return;

  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = 'application/pdf, image/jpeg';

  fileInput.onchange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      alert("Il file selezionato supera i 10 MB. Seleziona un file più piccolo.");
      return;
    }

    const fileType = file.type.includes('pdf') ? 'pdf' : file.type.includes('jpeg') ? 'jpg' : null;
    if (!fileType) {
      alert('Seleziona solo file PDF o JPG');
      return;
    }

    try {
      isLoading.value = true;

      const storage = getStorage();
      const filePath = `alimentazioni/${targetUserId}/${index}/${file.name}`;
      const fileRef = storageRef(storage, filePath);
      await uploadBytes(fileRef, file);

      const fileUrl = await getDownloadURL(fileRef);
      const dataFileCaricato = Timestamp.fromDate(new Date());
      const entriesToSave = isCurrentUser(targetUserId)
        ? cloneAlimentazioni(alimentazione.value)
        : entriesSnapshot;
      if (!entriesToSave[index]) {
        throw new Error('Alimentazione non trovata durante il caricamento.');
      }
      Object.assign(entriesToSave[index], { fileUrl, fileType, dataFileCaricato });
      if (isCurrentUser(targetUserId) && alimentazione.value[index]) {
        Object.assign(alimentazione.value[index], { fileUrl, fileType, dataFileCaricato });
      }

      await saveFileUrlToFirestore({
        targetUserId,
        index,
        fileUrl,
        fileType,
        dataFileCaricato,
        entries: entriesToSave,
        baseEntries: baseEntriesSnapshot,
      });
      if (isCurrentUser(targetUserId)) alert('File caricato con successo!');
    } catch (error) {
      console.error('Errore durante il caricamento del file:', error);
      if (isCurrentUser(targetUserId)) alert('Errore durante il caricamento del file.');
    } finally {
      if (isCurrentUser(targetUserId)) isLoading.value = false;
    }
  };

  fileInput.click();
};



const saveFileUrlToFirestore = async ({
  targetUserId,
  index,
  fileUrl,
  fileType,
  dataFileCaricato,
  entries,
  baseEntries,
}) => {
    const updatedAlimentazioni = entries.map((item, i) =>
      i === index
        ? { ...item, fileUrl, fileType, dataFileCaricato }
        : item
    );

    const savedEntries = await saveProtectedAlimentazioni({
      userId: targetUserId,
      entries: updatedAlimentazioni,
      baseEntries,
    });
    if (isCurrentUser(targetUserId)) replaceSavedAlimentazioni(savedEntries);
};

    const sendEmailForAlimentazione = async (item, fallbackIndex) => {
      if (!props.userId) {
        alert('Utente non trovato.');
        return;
      }
      const resolvedIndex = resolveAlimentazioneIndex(item);
      const targetIndex = resolvedIndex >= 0 ? resolvedIndex : fallbackIndex;
      const target = alimentazione.value[targetIndex];
      if (!target || !target.fileUrl) {
        alert('Carica prima il PDF per inviare l\'email.');
        return;
      }
      if (!hasStableAlimentazioneIds(alimentazione.value)) return;

      const targetUserId = props.userId;
      const baseEntriesSnapshot = cloneAlimentazioni(baseAlimentazioni.value);
      setSendingEmail(item, fallbackIndex, true);

      try {
        const requestAt = Date.now();
        const updatedAlimentazioni = alimentazione.value.map((entry, i) =>
          i === targetIndex
            ? { ...entry, invioEmail: true, emailRequestAt: requestAt }
            : entry
        );

        const savedEntries = await saveProtectedAlimentazioni({
          userId: targetUserId,
          entries: updatedAlimentazioni,
          baseEntries: baseEntriesSnapshot,
        });
        if (isCurrentUser(targetUserId)) replaceSavedAlimentazioni(savedEntries);
      } catch (error) {
        console.error('Errore durante l\'invio dell\'email:', error);
        if (isCurrentUser(targetUserId)) alert('Errore durante l\'invio dell\'email.');
      } finally {
        if (isCurrentUser(targetUserId)) setSendingEmail(item, fallbackIndex, false);
      }
    };
    const privacyText = computed(() => {
    return userPrivacyAccettata.value ? 'ACCETTATA' : 'NON ACCETTATA';
  });
    // Computed property per lo stato di visibilità
    const hiddenStatusText = computed(() => {
      return userHidden.value ? 'Nascosto' : 'Visibile';
    });

    // Computed property per il testo del bottone
    const hiddenStatusButtonText = computed(() => {
      return userHidden.value ? 'Rendi Visibile' : 'Nascondi Utente';
    });

    // Funzione per alternare lo stato di visibilità
    const toggleHiddenStatus = async () => {
  const targetUserId = props.userId;
  if (!targetUserId || isPageLoading.value || pageError.value) return;
  const db = getFirestore();
  const userRef = doc(db, "users", targetUserId);

  try {
    const newHiddenState = !userHidden.value;
    await updateDoc(userRef, { hidden: newHiddenState }); // Salva correttamente il campo hidden
    if (isCurrentUser(targetUserId)) userHidden.value = newHiddenState;
  } catch (error) {
    console.error("Errore nell'aggiornamento del campo hidden:", error);
  }
};




    // Funzione per modificare il link di Dropbox
    const modifyDropboxLink = (link) => {
      if (!link) {
        return link;
      }
      if (link.includes("dropbox.com") && link.includes("dl=0")) {
        return link.replace("dl=0", "raw=1");
      }
      return link;
    };

    // Funzione per formattare la data
    const formatDate = (timestamp) => {
      if (!timestamp) {
        return '';
      }
      let date;
      if (timestamp.toDate) {
        date = timestamp.toDate();
      } else {
        return '';
      }
      return date.toLocaleString('it-IT');
    };

    // Funzione per formattare la data delle prenotazioni
    const formatSlotDate = (dateStr) => {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Toggle accordion
    const toggleAccordion = (index) => {
      if (currentAccordion.value === index) {
        currentAccordion.value = null;
      } else {
        currentAccordion.value = index;
      }
    };


    

    const addNewMonth = () => {
  if (isPageLoading.value || pageError.value) return;
  const hasMissingLink = alimentazione.value.some(item => !item.linkAlimentazione);

  if (hasMissingLink) {
    const proceed = confirm("Sicuro di creare una nuova alimentazione? La precedente non ha il link del piano inserito.");
    if (!proceed) return;
  }

  alimentazione.value.push({
    id: createAlimentazioneId(),
    dataCreazione: Timestamp.fromDate(new Date()),
    nota1: '',
    nota2: '',
    linkAlimentazione: '',
    videocall: '',
    dataSelezioneSI: null,
    kcalalimentazioni: '', // Nuovo campo
    strategia: '', // Nuovo campo
    allenamento: '',
    freqallenamento: '',
    lavtrainer:''
  });
  currentAccordion.value = alimentazione.value.length - 1;
};

    const resetUserState = () => {
      alimentazione.value = [];
      baseAlimentazioni.value = [];
      userPrivacyAccettata.value = false;
      userHidden.value = false;
      codFiscale.value = '';
      luogoNascita.value = '';
      currentAccordion.value = null;
      sendingEmail.value = {};
      isLoading.value = false;
      isDragging.value = false;
      closeIntegrazioneModal();
      pageError.value = '';
    };

    const loadUserData = async (targetUserId) => {
      const requestId = ++activeLoadRequest;
      resetUserState();

      if (!targetUserId) {
        pageError.value = 'Utente non valido.';
        isPageLoading.value = false;
        return;
      }

      isPageLoading.value = true;
      try {
        const db = getFirestore();
        const [userDocSnap, alimentazioneDocSnap, prenotazioniSnapshot] = await Promise.all([
          getDoc(doc(db, 'users', targetUserId)),
          getDoc(doc(db, 'alimentazioni', targetUserId)),
          getDocs(collection(db, 'prenotazioni')),
        ]);
        if (requestId !== activeLoadRequest || !isCurrentUser(targetUserId)) return;

        const userData = userDocSnap.exists() ? userDocSnap.data() : {};
        userPrivacyAccettata.value = !!userData.privacyAccettata;
        userHidden.value = !!userData.hidden;
        codFiscale.value = userData.codFiscale || '';
        luogoNascita.value = userData.luogoNascita || '';

        const userBookings = [];
        prenotazioniSnapshot.forEach((bookingDoc) => {
          const booking = bookingDoc.data();
          if (booking.userId === targetUserId) userBookings.push(booking);
        });
        const entries = alimentazioneDocSnap.exists() && Array.isArray(alimentazioneDocSnap.data()?.alimentazioni)
          ? alimentazioneDocSnap.data().alimentazioni
          : [];
        replaceSavedAlimentazioni(entries.map((entry) => ({
          ...entry,
          prenotazioni: userBookings,
        })));
      } catch (error) {
        if (requestId !== activeLoadRequest || !isCurrentUser(targetUserId)) return;
        console.error('Errore durante il caricamento delle alimentazioni:', error);
        pageError.value = 'Impossibile caricare le alimentazioni. Riprova.';
      } finally {
        if (requestId === activeLoadRequest && isCurrentUser(targetUserId)) {
          isPageLoading.value = false;
        }
      }
    };



const saveAlimentazione = async () => {
  const targetUserId = props.userId;
  if (!targetUserId) {
    alert('Utente non trovato.');
    return;
  }
  if (isPageLoading.value || pageError.value) return;
  if (!hasStableAlimentazioneIds(alimentazione.value)) return;
  const baseEntriesSnapshot = cloneAlimentazioni(baseAlimentazioni.value);

  // Prepara i dati per il salvataggio, inclusi i nuovi campi
  const alimentazioneToSave = {
    userId: targetUserId,
    alimentazioni: alimentazione.value.map(item => {
      let modifiedLink = modifyDropboxLink(item.linkAlimentazione);

      // Usa dataFileCaricato se disponibile, altrimenti calcola una nuova data se il file URL è presente
      let dataFileCaricato = item.dataFileCaricato 
        ? item.dataFileCaricato 
        : (item.fileUrl ? Timestamp.fromDate(new Date()) : null);

      return {
        ...item,
        id: item.id,
        linkAlimentazione: modifiedLink,
        dataFileCaricato, // Salva la data del caricamento del file
        dataSelezioneSI: item.dataSelezioneSI || null,
        kcalalimentazioni: item.kcalalimentazioni || '', // Nuovo campo
        strategia: item.strategia || '', // Nuovo campo
        freqallenamento: item.freqallenamento || '', // Nuovo campo
        allenamento: item.allenamento || '', // Nuovo campo
        lavtrainer: item.lavtrainer || '', // Nuovo campo

      };
    })
  };

  try {
    const savedEntries = await saveProtectedAlimentazioni({
      userId: targetUserId,
      entries: alimentazioneToSave.alimentazioni,
      rootPatch: { userId: targetUserId },
      baseEntries: baseEntriesSnapshot,
    });
    if (isCurrentUser(targetUserId)) {
      replaceSavedAlimentazioni(savedEntries);
      alert("Alimentazione salvata con successo!");
    }
  } catch (error) {
    console.error("Errore durante il salvataggio:", error);
    if (isCurrentUser(targetUserId)) alert("Errore nel salvataggio.");
  }
};
    watch(
      () => props.userId,
      (nextUserId) => loadUserData(nextUserId),
      { immediate: true }
    );

    return {
      alimentazione,
      saveAlimentazione,
      formatDate,
      formatSlotDate,
      toggleAccordion,
      addNewMonth,
      currentAccordion,
      modifyDropboxLink,
      privacyText,
      hiddenStatusText, // Mostra se l'utente è visibile o nascosto
      hiddenStatusButtonText, // Testo del bottone per cambiare lo stato
      toggleHiddenStatus,
      uploadFile,
      isLoading,
      isPageLoading,
      pageError,
      handleDrop,
      isDragging,
      showTooltip,
      sortedAlimentazioni,
      integrazioneModal,
      openIntegrazioneModal,
      closeIntegrazioneModal,
      handleIntegrazioneSaved,
      getIntegrationLabel,
      getIntegrationSummary,
      getAlimentazioneKey,
      sendEmailForAlimentazione,
      isSendingEmail
    };
  }
};
</script>



<style scoped>

.user-alimentazione-status {
  margin: 12px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #eef2ff;
  color: #3730a3;
  font-size: 13px;
}

.user-alimentazione-status--error {
  background: #fef2f2;
  color: #b91c1c;
}

.divider {
  height: 10px; /* Altezza del divisore */
  background-color: #3578d6; /* Colore grigio */
  width: 100%; /* Larghezza completa */
  margin: 20px 0; /* Spazio sopra e sotto */
}


.tooltip-content .highlight {
  color: #ff4d4d; /* Colore rosso */
  font-weight: bold; /* Grassetto */
}

.info-icon {
  display: inline-block;
  margin-left: 5px;
  margin-top: 5px;
  cursor: pointer;
  position: relative;
  font-size: 18px;
  color: #ba0000;
}
.tooltip-content {
  position: absolute;
  background-color: #333;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  top: -450px;
  left: 100%;
  z-index: 10;
  font-size: 12px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  width: 900px; /* Maggiore larghezza per il testo */
  white-space: normal; /* Consente il testo a capo */
  margin-left: 10px;
}

.tooltip-content ul {
  padding-left: 20px;
  margin: 0;
  list-style-type: disc;
}



.drop-zone {
  border: 2px dashed #ccc;
  padding: 25px;
  text-align: center;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  margin-bottom: 10px;
}
.drop-zone--active {
  background-color: #e0e0e0;
}
.file-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.send-email-btn {
  background-color: #1d4ed8;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}

.send-email-btn:hover {
  background-color: #1e40af;
}

.send-email-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.button-container {
  margin-bottom: 100px;
}
.header-text2 {
  font-weight: bold;
}
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-header2 {
  display: flex;
  align-items: center;
  background-color: #f0f0f0; /* Colore di sfondo dell'header */
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.additional-info {
  margin-left: auto;
  display: flex;
  gap: 15px;
  align-items: center;
  font-size: 0.9em;
  color: #333;
}

.delete-button {
  margin-left: 80px;
  background-color: #d9534f;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.delete-button:hover {
  background-color: #c9302c;
}




.full-width2 {
  margin-bottom: 20px;
  background-color: #656565;
  color: #ffffff;
  padding: 30px;
}

.full-width {
  margin-bottom: 20px;
}


.user-textarea, .user-textarea-red, .user-input {
  width: 100%;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #ccc;
  box-sizing: border-box;
min-height: 45px;
}

.user-textarea:focus, .user-textarea-red:focus, .user-input:focus {
  outline: none;
  border-color: #4d4d4d;
}

.grid-container2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 50px;
  row-gap: 20px;
  max-width: 98%;
}

.data-creazione {
  margin-top: 15px;
  margin-bottom: 25px;
  color: #ffffff;
}

.user-textarea-red {
  height: 200px;
  resize: vertical;
}

.user-textarea-red {
  padding: 13px 12px;
  border-radius: 12px;
  border: 1px solid #9b0000;
  background-color: rgba(28, 28, 28, 0.3);
  color: white;
  width: 100%;
}

.user-textarea-red:focus {
  outline: none;
  border-color: #4d4d4d;
}

.prenotazioni-container {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #1b1b1b;
  color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.prenotazioni-container h3 {
  margin-top: 0;
}

.prenotazioni-container ul {
  list-style-type: none;
  padding-left: 0;
}

.prenotazioni-container li {
  padding: 5px 0;
  border-bottom: 1px solid #ccc;
}

.prenotazioni-container li:last-child {
  border-bottom: none;
}

.integrazione-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.integrazione-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #474747;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 10px rgba(31, 41, 55, 0.2);
  height: 50px;
}

.integrazione-button:hover {
  background: #a3a3a3;
  transform: translateY(1px);
}

.integrazione-button__icon {
  font-size: 18px;
}

.integrazione-summary {
  font-size: 12px;
  color: #374151;
  line-height: 1.4;
}
</style>
